import React from "react";

export const MicroButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return (
        <button onClick = { onClick } 
            className="bg-neutral-900 px-4 rounded-full text-xl hover:bg-neutral-800 text-white">
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                strokeWidth="1.5" 
                stroke="currentColor" 
                className="w-6 h-6">
            <path 
                strokeLinecap="round" 
                strokeLinejoin="round"
                d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z" />
            </svg>

        </button>
    );
};